module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fourzefour-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/404.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-96c3a02e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 1733
// module chunks = 0